import { watch } from 'vue';

/*
    Our master function! Import the functions you need in App.vue,
    overwrite them if necessary, and then call 'useDottieInit' to
    set everything going.
*/
export function useDottieInit(
    categoriesQuery,
    categoriesStore,
    config,
    facetsQuery,
    facetsStore,
    locationsQuery,
    locationsStore,
    pageSettings,
    paginatedListingsQuery,
    queryParams,
    regionsQuery,
    regionsStore,
    resultsStore,
    routing,
    useCategories,
    useFacets,
    useFetch,
    useParams,
    usePlaces,
) {

    async function doDottieInit() {

        /*
            get initial param values from URL,
            get page settings from meta element
        */
        const paramsFromUrl = routing.getParamsFromUrl();
        const settings = await pageSettings(config.metaId);

        /*
            set up our core functionality, ready to use
        */
        const {
            getCategories,
            watchCategories
        } = useCategories(
            queryParams,
            categoriesQuery,
            categoriesStore,
            facetsQuery,
            facetsStore,
            paramsFromUrl,
            settings,
            useFetch,
        );

        const {
            getFacets,
            watchFacets
        } = useFacets(
            categoriesStore,
            facetsQuery,
            facetsStore,
            queryParams,
            paramsFromUrl,
            settings,
            useFetch,
        );

        const {
            getPlaces,
            watchPlaces
        } = usePlaces(
            locationsStore,
            locationsQuery,
            paramsFromUrl,
            queryParams,
            regionsStore,
            regionsQuery,
            settings,
            useFetch,
        );

        const {
            getResults,
            watchParams
        } = useParams(
            categoriesStore,
            paginatedListingsQuery,
            queryParams,
            resultsStore,
            routing,
            settings,
            useFetch,
            config,
        );

        /*
            set initial search param values
        */
        await routing.setInitialParamValues(paramsFromUrl, queryParams);

        /*
            set up filters
        */
        await getCategories();
        await getFacets();
        await getPlaces();

        /*
            get initial results
        */
        await getResults();

        /*
            watch for changes in filters and query params
        */
        watchCategories();
        watchFacets();
        watchPlaces();
        watchParams();

    }

    doDottieInit();

}
